import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'insertHtml',
	standalone: true
})
export class InsertHtmlPipe implements PipeTransform {
	public transform(value: string, tag: string, id = '', cssClass = ''): string {
		return `<${tag} id="${id}" class="${cssClass}">${value}</${tag}>`;
	}
}
